import {useEffect, useRef, useState} from "react";
import './Header.css';
import {useLocation, useNavigate} from "react-router-dom";
import UserWidget from "../UserWidget/UserWidget.jsx";
import {useMediaQuery} from "react-responsive";
import HeaderNavbar from "./sub/HeaderNavbar/HeaderNavbar.jsx";
import HamburgerMenu from "./sub/HamburgerMenu/HamburgerMenu.jsx";
import HeaderSearch from "./sub/HeaderSearch/HeaderSearch.jsx";

export default function Header({
                                   setDisplayBasketWidget, setDisplayUserWidget, displayUserWidget,
                                   loggedUser, setLoggedUser
                               }) {
    const navigate = useNavigate();
    const location = useLocation();
    const userWidgetRef = useRef();
    const isMobile = useMediaQuery({maxWidth: 768});
    const [displayHamburger, setDisplayHamburger] = useState(false);

    const base = `/produkty`;

    const dropdownData = [
        {
            name: "Rzęsy",
            image: "https://lumestore.pl/images/eyelashes-icon.png",
            link: `${base}/rzesy`,
            sub: [
                { name: "Rzęsy czarne",   link: `${base}/rzesy/rzesy-czarne` },
                { name: "Rzęsy brązowe",  link: `${base}/rzesy/rzesy-brazowe` },
                { name: "Rzęsy kolorowe", link: `${base}/rzesy/rzesy-kolorowe` }
            ]
        },
        {
            name: "Pęsety",
            image: "https://lumestore.pl/images/tweezers-icon.png",
            link: `${base}/pesety`,
            sub: [
                { name: "Do rzęs", link: `${base}/pesety/do-rzes` },
                { name: "Do brwi", link: `${base}/pesety/do-brwi` }
            ]
        },
        {
            name: "Kleje",
            image: "https://lumestore.pl/images/glues-icon.png",
            link: `${base}/kleje`,
            sub: [
                { name: "Kleje",    link: `${base}/kleje/kleje` },
                { name: "Kleje UV", link: `${base}/kleje/kleje-uv` }
            ]
        },
        {
            name: "Preparaty",
            image: "https://lumestore.pl/images/specimen-icon.png",
            link: `${base}/preparaty`,
            sub: [
                { name: "Szampony", link: `${base}/preparaty/szampony` },
                { name: "Primery",  link: `${base}/preparaty/primery` },
                { name: "Cleanery", link: `${base}/preparaty/cleanery` },
                { name: "Boostery", link: `${base}/preparaty/boostery` },
                { name: "Removery", link: `${base}/preparaty/removery` }
            ]
        },
        {
            name: "Taśmy i płatki",
            image: "https://lumestore.pl/images/tapes-icon.png",
            link: `${base}/tasmy-i-platki`,
            sub: [
                { name: "Taśmy",    link: `${base}/tasmy-i-platki/tasmy` },
                { name: "Płatki",   link: `${base}/tasmy-i-platki/platki` },
                { name: "Nożyczki", link: `${base}/tasmy-i-platki/nozyczki` }
            ]
        },
        {
            name: "Akcesoria",
            image: "https://lumestore.pl/images/accessories-icon.png",
            link: `${base}/akcesoria`,
            sub: [
                { name: "Holdery",           link: `${base}/akcesoria/holdery` },
                { name: "Tryskawki",         link: `${base}/akcesoria/tryskawki` },
                { name: "Poduszki",          link: `${base}/akcesoria/poduszki` },
                { name: "Wiatraczki",        link: `${base}/akcesoria/wiatraczki` },
                { name: "Pojemniczki",       link: `${base}/akcesoria/pojemniczki` },
                { name: "Podstawki na klej", link: `${base}/akcesoria/podstawki-na-klej` },
                { name: "Lusterka",          link: `${base}/akcesoria/lusterka` }
            ]
        },
        {
            name: "Jednorazowe",
            image: "https://lumestore.pl/images/disposables-icon.png",
            link: `${base}/jednorazowe`,
            sub: [
                { name: "Aplikatory i szczoteczki", link: `${base}/jednorazowe/aplikatory-i-szczoteczki` },
                { name: "Maseczki",                 link: `${base}/jednorazowe/maseczki` },
                { name: "Rękawiczki",               link: `${base}/jednorazowe/rekawiczki` },
                { name: "Podkłady kosmetyczne",     link: `${base}/jednorazowe/podklady-kosmetyczne` },
                { name: "Waciki",                   link: `${base}/jednorazowe/waciki` }
            ]
        },
        {
            name: "Brwi",
            image: "https://lumestore.pl/images/eyebrows-icon.png",
            link: `${base}/brwi`,
            sub: [
                { name: "Farby",                  link: `${base}/brwi/farby` },
                { name: "Stylizacja i pielęgnacja", link: `${base}/brwi/stylizacja-i-pielegnacja` },
                { name: "Preparaty",              link: `${base}/brwi/preparaty` },
                { name: "Geometria",              link: `${base}/brwi/geometria` },
                { name: "Pędzle",                 link: `${base}/brwi/pedzle` },
                { name: "Akcesoria",              link: `${base}/brwi/akcesoria` }
            ]
        },
        {
            name: "Laminacja",
            image: "https://lumestore.pl/images/lamination-icon.png",
            link: `${base}/laminacja`,
            sub: [
                { name: "Koreańska laminacja", link: `${base}/laminacja/koreanska-laminacja` },
                { name: "Laminacja rzęs",      link: `${base}/laminacja/laminacja-rzes` },
                { name: "Laminacja brwi",      link: `${base}/laminacja/laminacja-brwi` }
            ]
        },
        {
            name: "Depilacja",
            image: "https://lumestore.pl/images/wax-icon.png",
            link: `${base}/depilacja`,
            sub: []
        },
        {
            name: "UV",
            image: "https://lumestore.pl/images/uv-icon.png",
            link: `${base}/uv`,
            sub: []
        },
        {
            name: "Karta klienta",
            image: "https://lumestore.pl/images/client-card-icon-v5.png",
            link: `${base}/karta-klienta`,
            sub: []
        }
    ];

    useEffect(() => {
        if (isMobile === false) {
            setDisplayHamburger(false);
        }
    }, [isMobile]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (userWidgetRef.current && !userWidgetRef.current.contains(e.target)) {
                setDisplayUserWidget(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setDisplayUserWidget]);

    useEffect(() => {
        setDisplayUserWidget(false);
    }, [location.pathname]);

    return <div id='header'>
        <div id="header-top">
            <div id="header-top-wrapper">
                <div id='header-logo' onClick={() => navigate('/')}>
                    <img loading="lazy" src='/logo/logo-lume-store2.webp' alt="Lume Store logo"/>
                    {import.meta.env.VITE_IS_CHRISTMAS === true && (
                        <div id='header-logo-hat-container'>
                            <img loading="lazy" src="/images/santa-hat-icon.png" alt="santa hat icon"/>
                        </div>
                    )}
                </div>
                {!isMobile && (
                    <div id='header-search-wrapper'>
                        <HeaderSearch/>
                    </div>
                )}
                <div id='header-bttns-container'>
                    <div id='cart-bttn' className='header-bttn'>
                        <div id='cart-bttn-icon' className='header-bttn-icon'
                             onClick={() => setDisplayBasketWidget(true)}>
                            <img src='/images/basket-icon.webp' alt="Koszyk"/>
                        </div>
                    </div>
                    <div id='account-bttn' className='header-bttn'>
                        <div id='account-bttn-icon' className='header-bttn-icon'
                             onClick={() => window.location.href = 'https://lumestore-pl.myshopify.com/customer_authentication/redirect'}>
                            <img src='/images/account-icon.webp' alt="Moje konto"/>
                        </div>
                        {/*{displayUserWidget && (*/}
                        {/*    <div ref={userWidgetRef}>*/}
                        {/*        <UserWidget loggedUser={loggedUser} setLoggedUser={setLoggedUser}/>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                    </div>
                </div>
            </div>
            {isMobile && (
                <div id='header-search-wrapper'>
                    <div id='header-hamburger-bttn' onClick={() => setDisplayHamburger(!displayHamburger)}></div>
                    <HeaderSearch/>
                </div>
            )}
        </div>
        {!isMobile && (
            <div id='header-bottom'>
                <HeaderNavbar dropdownData={dropdownData}/>
            </div>
        )}
        {isMobile && (
            <HamburgerMenu
                setDisplayHamburger={setDisplayHamburger}
                content={dropdownData}
                displayHamburger={displayHamburger}
            />
        )}
        {import.meta.env.VITE_IS_CHRISTMAS === true ? (
            <div id='header-christmas-ribbon-container' style={{backgroundImage: `url(/images/christmas-ribbon-2.png)`}}>
                <img id='header-christmas-ribbon' src={'/images/christmas-ribbon-1.png'} alt='christmas-ribbon'/>
            </div>
        ) : <></>}
    </div>;
}